import Axios from "axios";
import {URLSearchParams} from "core-js/modules/web.url-search-params.constructor";

class ProductFilter {
    constructor() {
        this.url = window.location;
        this.baseUrl = this.url.origin;


        this.buttons = document.querySelectorAll('.p-filter-categories__button');
        this.resetButtons = document.querySelectorAll('.p-filter-reset');
        this.ecoCheckbox = document.querySelector('.p-filter-categories__eco');
        this.productList = document.querySelector('.productTeaser__list');
        this.selectUsages = document.querySelector('#p-filter-options__select-usages');
        this.selectTechnologies = document.querySelector('#p-filter-options__select-technologies');
        this.allButton = Array.from(this.buttons).find(button => button.getAttribute('data-category') === '0');

        this.category = 0;
        this.eco = false;
        this.usage = 0;
        this.technology = 0;

        if(this.buttons && this.resetButtons && this.ecoCheckbox){
            this.init();
        }

    }



    init() {
        this.presetFilters();
        this.filterClickHandler();
        this.filterProducts();

    }
    setUrlParams(){

        let params = new URLSearchParams(window.location.search);
        params.set('category', this.category);
        params.set('eco', this.eco);
        params.set('usage', this.usage);
        params.set('technology', this.technology);
        window.history.replaceState( window.history.state , 'test', '?'+params.toString() );


    }
    getUrlParams(){
        const queryString = window.location.search;
        const urlParams = new URLSearchParams(queryString);

        return urlParams;
    }
    presetFilters() {
        const urlParams = this.getUrlParams();


        if(window.location.search != ''){
            if(urlParams.has('category')){
                this.category = urlParams.get('category');
            }
            if(urlParams.has('eco')){

                if(urlParams.get('eco') == 'true') {
                    this.eco = true;
                } else {
                    this.eco = false;
                }

            }
            if(urlParams.has('usage')){
                this.usage = urlParams.get('usage');
            }
            if(urlParams.has('technology')){
                this.technology = urlParams.get('technology');
            }





            this.setFilters();
        } else {
            let options = this.getLocalStorage();

            if(options){
                this.category = options.category;
                this.eco = Boolean(options.eco);
                this.usage = options.usage;
                this.technology = options.technology;
                this.setFilters();
            }
        }


    }
    setFilters() {

        this.ecoCheckbox.checked = this.eco;

        this.selectUsages.value = this.usage;
        this.selectTechnologies.value = this.technology;
        this.removeActiveButtonClass();
        this.buttons.forEach(button => {
            if(button.getAttribute('data-category') == this.category){
                button.classList.add('p-filter-categories__button--active');
            }
        });


    }
    filterClickHandler(){
        let self = this
        this.buttons.forEach(button => {
            button.addEventListener('click', () => {
                if (!button.classList.contains('p-filter-categories__button--active')) {


                    this.removeActiveButtonClass();
                    button.classList.toggle('p-filter-categories__button--active');
                    this.category = button.getAttribute('data-category');
                } else if(button.getAttribute('data-category') === '0'){
                    this.category = 0;
                } else {

                    this.setAllProductCategoryActive();
                    button.classList.toggle('p-filter-categories__button--active');
                    this.category = 0;
                }

                this.filterProducts();
            });
        });

        this.ecoCheckbox.addEventListener('change', function() {
            if (this.checked) {
                self.eco = true;
            } else {
                self.eco = false;
            }
            self.filterProducts();
        });

        this.selectUsages.addEventListener('change', function() {
            self.usage = this.value;
            self.filterProducts();
        });
        this.selectTechnologies.addEventListener('change', function() {
            self.technology = this.value;
            self.filterProducts();
        });

        this.resetButtons.forEach(button => {
            button.addEventListener('click', () => {
                this.resetFilters();

                this.filterProducts();
            });
        });


    }

    resetFilters() {
        this.category = 0;
        this.eco = false;
        this.usage = 0;
        this.technology = 0;

        this.removeActiveButtonClass();
        this.setAllProductCategoryActive();
        this.ecoCheckbox.checked = false;
        this.selectUsages.getElementsByTagName('option')[0].selected = 'selected';
        this.selectTechnologies.getElementsByTagName('option')[0].selected = 'selected';
    }

    getAllOptions() {
        let options = {
            eco: this.eco,
            category: this.category,
            usage: this.usage,
            technology: this.technology
        };
        return options;
    }

    removeActiveButtonClass() {
        this.buttons.forEach(button => {
            button.classList.remove('p-filter-categories__button--active');
        });
    }

    setAllProductCategoryActive() {
        this.allButton.classList.add('p-filter-categories__button--active');
    }
    setLocalStorage(options){
        localStorage.setItem('product-filter', JSON.stringify(options));
    }
    getLocalStorage(){
        return JSON.parse(localStorage.getItem('product-filter'));
    }

    filterProducts(){

        this.setLocalStorage(this.getAllOptions());

        this.setUrlParams();


        Axios(this.generateRequestData()).then((result) => {


//console.log(result.data.data.productEntries);

            this.addProducts(result.data.data.productEntries);
        });
    }

    addProducts(products){

        this.productList.innerHTML = '';


        if(products.length > 0){

            for(let product in products){

                this.addProductEntry(products[product]);
            }
        }
    }

    addProductEntry(product) {

        const productImage = product.productImage;

        let picture ='';

        if(productImage.length){

            picture =`<picture>`;


                picture += `<source srcset="${productImage[0].urlMobileWebp}" media="(max-width:767px)">`;

                picture += `<img src="${productImage[0].urlDesktopWebp}" class="lazyload img-product-card"  loading="eager">`;


            picture += `</picture>`;
        }







        let html = `<a href="${product.productLink[0].url}" class="product-card">
    <div class="product-card__image">
                            
<figure class="figure figure-product-card">
`+picture+`
</figure>
            </div>
    <div class="product-card__content">
                <div class="product-card__subtitle">

            ${product.productTechnology[0].title}
        </div>
        <div class="product-card__title">
            ${product.title}
        </div>
        <div class="product-card__teaser">
            ${product.productTeaserText}
        </div>
    </div>
    <div class="product-card__action"><div class="action action-fab"></div></div>
</a>`;
        this.productList.insertAdjacentHTML("afterbegin", html);
    }

    getQueryString(){

        let array = [];

        if(this.usage != 0){
            array.push(`{id: "${this.usage}"}`);
        }
        if(this.technology != 0){
            array.push(`{id: "${this.technology}"}`);
        }

        if (array.length) {
            return `, relatedToEntries: [${array.join(", ")}]`;
        } else {
            return ``;
        }
    }

    getCurrentLanguage() {
        let lang = 'default';
        let langAttr = document.documentElement.lang;
        if(langAttr == 'fr-CH') {
            lang = 'collanoFr';
        } else if(langAttr == 'en'){
            lang = 'collanoEn';
        } else if(langAttr == 'de-CH'){
            lang = 'default';
        }

        return lang;
    }
    getGraphQLquery() {


        const language = this.getCurrentLanguage();


        let productTypeString = '';
        if(this.category == 1){
            productTypeString = ', productType: "adhesive" ';
        } else if(this.category == 2) {
            productTypeString = ', productType: "aids" ';
        }

        let ecoString = '';
        if(this.eco){
            ecoString = 'productMinergieEcoStandard: true';
        }

        return `query {
            
        productEntries(site: "${language}", orderBy: "title desc" ${ecoString ? ', ' + ecoString : ''} ${productTypeString} ${this.getQueryString()}) {

            ... on product_default_Entry {
                title
                url
                productImage {
                    id  
                    ... on uploads_Asset {
                       urlMobileWebp: url(transform: "productMobile")
                        urlDesktopWebp: url(transform: "productDesktop")
                    }
                    
                    ... on products_Asset {
                      urlMobileWebp: url(transform: "productMobile")
                        urlDesktopWebp: url(transform: "productDesktop")
                    }

                }
                productUsage {
                  id
                  title
                }
                productTechnology {
                  id
                  title
                }
                productMinergieEcoStandard
                productType
                productTeaserText
                productDescription
                productLink {
                url
                }

            }    
            }
        }`;
    }

    generateRequestData() {


        return {
            url: `${this.baseUrl}/graphql`,
            method: 'POST',
            headers: {

                /*'Authorization': `Basic ${token}`*/

            },
            data: {
                query: this.getGraphQLquery(),
            }
        };
    }
}
export default ProductFilter;